var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasAuth())?_vm._t("default"):[(_vm.hasCustomNoAuthComponent)?_vm._t("noauth"):_c('div',[_vm._v(" 没有权限 ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }